import { render, staticRenderFns } from "./committeeDetail.vue?vue&type=template&id=13ef7c7f"
import script from "./committeeDetail.vue?vue&type=script&lang=js"
export * from "./committeeDetail.vue?vue&type=script&lang=js"
import style0 from "./committeeDetail.vue?vue&type=style&index=0&id=13ef7c7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports